/**
 * DBR-1280 원본 WebP와 최종 Figma 프레임의 배경. 중앙 콘텐츠의 기준 폭은 1260px이다.
 * 이미지 제공은 S3 CDN을 사용한다. 이 경로에 파일을 먼저 업로드한 뒤 앱을 배포한다.
 * S3 객체 경로: marketing/homepage/Main/PC/subject/prepare/261103/
 */
export const PREPARE_ASSET_PREFIX = 'https://s.wink.co.kr/marketing/homepage/Main/PC/subject/prepare/261103';

export const prepareAsset = (filename: string): string => `${PREPARE_ASSET_PREFIX}/${filename.replace(/^\/+/, '')}`;

export const panels = {
    hero: { height: 810, image: 'contents-0.webp' },
    expertise: { height: 772, image: 'contents-1.webp' },
    access: { height: 896, image: 'contents-2.webp' },
    introduction: { height: 2077, image: 'contents-3.webp' },
    'math-title': { height: 248, image: 'contents-4-1.webp' },
    'math-basics': { height: 578, image: 'contents-4-2.webp' },
    'math-courses': { height: 958, image: 'contents-4-3.webp' },
    'math-prescription': { height: 595, image: 'contents-4-4.webp' },
    'math-expert': { height: 644, image: 'contents-4-5.webp' },
    'subjects-title': { height: 250, image: 'contents-5-1.webp' },
    korean: { height: 974, image: 'contents-5-2.webp' },
    'social-science': { height: 1039, image: 'contents-5-3.webp' },
    'exams-title': { height: 249, image: 'contents-6-1.webp' },
    exams: { height: 793, image: 'contents-6-2.webp' },
    'teachers-title': { height: 250, image: 'contents-7-1.webp' },
    teachers: { height: 1823, image: 'contents-7-2.webp' },
    comparison: { height: 1750, image: 'contents-8.webp' },
    closing: { height: 500, image: 'contents-9.webp' },
} as const;

export type PanelName = keyof typeof panels;
